import { prepareSortedOptions } from '../../prepareOptions';
import {
  PANORAMIC_ROOF,
  ROOF_BARS,
  KEYLESS_ENTRY,
  TRAILER_HITCH,
  SUNROOF,
  HAS_ALLOY_RIMS,
  HAS_SPORT_PACKAGE,
} from './values';

export default prepareSortedOptions([
  {
    value: SUNROOF,
    label: __('carDetails.equipmentGroups.sunroof'),
  },
  {
    value: PANORAMIC_ROOF,
    label: __('carDetails.equipmentGroups.panoramicRoof'),
  },
  {
    value: ROOF_BARS,
    label: __('carDetails.equipmentGroups.roofRacksRoofRackRoofBox'),
  },

  {
    value: TRAILER_HITCH,
    label: __('carDetails.equipmentGroups.trailerHitch'),
  },
  {
    value: KEYLESS_ENTRY,
    label: __('carDetails.equipmentGroups.keylessEntry'),
  },
  {
    value: HAS_ALLOY_RIMS,
    label: __('carDetails.features.hasAlloyRims'),
  },
  {
    value: HAS_SPORT_PACKAGE,
    label: __('carDetails.features.hasSportPackage'),
  },
]);
